import req from "../../../services/psikotest/request";

class Rac {
  async get() {
    try {
      const res = await req.get("/api/psikotest_system/rac/");
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
  async update(data: TPSRac) {
    try {
      const res = await req.put("/api/psikotest_system/rac/", data);
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
  async questionary() {
    try {
      const res = await req.get("/api/psikotest_system/rac/questionary");
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
}

export default Rac;
